export enum ViewUrlSegment {
    View = 'view',
    Share = 'share',
}
